
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { GridModule, GridNoRowsComponent } from '@mds/ui';
import { GridOverrides, numberValueConversion, RowSelection } from '@mds/common';
import { GridApi } from 'ag-grid-community';

@Component({
  selector: 'app-score-compare-table',
  templateUrl: './score-compare-table.component.html',
  styleUrls: ['./score-compare-table.component.scss'],
  standalone: true,
  imports: [GridModule]
})
export class ScoreCompareTableComponent implements OnChanges {
  @Input() data: any;
  overrides: GridOverrides;
  rowData: any[] = [];
  bodyRowData = [];
  products = [];
  @Output() scenarioAgGridEmit = new EventEmitter<any>();

  ngOnChanges() {
    // upadte the incoming value from Parent
    this.overrides = undefined;
    if (this.data) {
      this.createGridData(this.data);
    }
  }

  private createGridData(data) {
    this.rowData = this.getRowData(data);
    const columnData = this.getColumns(data?.lines);

    this.overrides = {
      columnDefs: columnData,
      rowData: this.rowData,
      defaultColDef: {
        headerCheckboxSelectionFilteredOnly: true,
        lockPosition: true,
        lockPinned: true,
        sortable: true,
        resizable: true,
        filter: true,
        floatingFilter: true
      },

      sideBar: {
        toolPanels: [
          {
            id: 'columns',
            labelDefault: 'Columns',
            labelKey: 'columns',
            iconKey: 'columns',
            toolPanel: 'agColumnsToolPanel'
          }
        ]
      },
      pinnedBottomRowData: this.totalPinnedBottomRowData(),
      suppressRowClickSelection: true,
      rowSelection: RowSelection.MULTIPLE,
      noRowsOverlayComponent: GridNoRowsComponent,
      paginationAutoPageSize: false,
      pagination: false,
      noRowsOverlayComponentParams: {
        title: 'No data to show the table',
        description: 'Add data and it will start showing rows here'
      }
    };
  }

  getColumns(lines: any): any[] {
    const columnDefs = [
      {
        headerName: 'Nr',
        filter: '',
        floatingFilter: false,
        lockPosition: false,
        pinned: 'left',
        maxWidth: 100,
        field: 'Nr',
        cellClass: 'groupstart',
        headerClass: 'groupstart',
        groupHeaderClass: 'groupstart'
      },

      {
        headerName: 'Impact Category',
        filter: '',
        floatingFilter: false,
        lockPosition: false,
        pinned: 'left',
        minWidth: 50,
        field: 'name',
        cellClass: 'groupstart',
        headerClass: 'groupstart',
        groupHeaderClass: 'groupstart'
      },
      {
        headerName: 'Weighted & Normalized (pt)',
        children: this.columnChildrenBody(lines)
      }
    ];
    return columnDefs;
  }

  columnChildrenBody(lines) {
    return lines.map((el, index) => {
      const def = {
        headerName: el.name,
        filter: 'agTextColumnFilter',
        floatingFilter: false,
        lockPosition: false,
        pinned: 'left',
        minWidth: 100,
        field: el.name,
        cellStyle: { 'text-align': 'left' },
        valueFormatter: (params) => numberValueConversion(params.value)
      };
      if (index === 0) {
        return {
          ...def,
          cellClass: 'groupstart',
          headerClass: 'groupstart',
          groupHeaderClass: 'groupstart'
        };
      }
      return def;
    });
  }

  getRowData(data: any): Record<string, any>[] {
    data.lines[0].impacts.forEach((imp, index) => {
      const obj = {
        Nr: index + 1,
        name: imp.category
      };
       
      data.lines.map((line) => {
        const impt = line.impacts.find((im) => im.category === imp.category);
        obj[line.name] = impt.normalized && !isNaN(impt.normalized) ? +impt.normalized : 0;
        if (!this.products.includes(line.name)) this.products.push(line.name);
      });
      this.bodyRowData.push(obj);
    });
    return this.bodyRowData;
  }

  totalPinnedBottomRowData() {
    const totalRow = {
      name: 'PEF Score (Pt)'
    };
    this.bodyRowData.forEach((row) => {
      for (const key in row) {
        if (key !== 'Nr' && key !== 'name') {
          const value = row[key];
          if (typeof value === 'number') {
            totalRow[key] = (totalRow[key] || 0) + value;
          }
        }
      }
    });
    return [totalRow];
  }

  onGridReady(gridApi: GridApi) {
    this.scenarioAgGridEmit.emit(gridApi);
  }
}
